<script setup>
// @ts-nocheck
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import SidenavItem from "./SidenavItem.vue";


const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
</script>
<template>
  <head>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css" rel="stylesheet">
  </head>
  <div
      class="collapse navbar-collapse w-auto h-auto h-100"
      id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
            class="navMenuItems"
            to="/dashboard-default"
            :class="getRoute() === 'dashboard-default' ? 'active' : ''"
            :navText="isRTL ? 'Anasayfa' : 'Anasayfa'"
        >
          <template v-slot:icon>
            <i class="bi bi-house-door-fill text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
            class="navMenuItems"
            to="/companies"
            :class="getRoute() === 'companies' ? 'active' : ''"
            :navText="isRTL ? 'Firmalar' : 'Firmalar'"
        >
          <template v-slot:icon>
            <i class="bi bi-building  text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
            class="navmenuitems"
            to="/company-officials"
            :class="getRoute() === 'companyOfficials' ? 'active' : ''"
            :navText="isRTL ? 'Firma Yetkilileri' : 'Firma Yetkilileri'"
        >
          <template v-slot:icon>
            <i class="bi bi-people  text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
            class="navmenuitems"
            to="/definitions-personal"
            :class="getRoute() === 'definitions-personal' ? 'active' : ''"
            :navText="isRTL ? 'Personel ' : 'Personel '"
        >
          <template v-slot:icon>
            <i class="bi bi-person  text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
            class="navmenuitems"
            to="/users"
            :class="getRoute() === 'users' ? 'active' : ''"
            :navText="isRTL ? 'Kullanıcı (M.Temsilcisi)' : 'Kullanıcı (M.Temsilcisi)'"
        >
          <template v-slot:icon>
            <i class="bi bi-people  text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
            class="navmenuitems"
            to="/profile"
            :class="getRoute() === 'profile' ? 'active' : ''"
            :navText="isRTL ? 'Sözleşmeler' : 'Sözleşmeler'"
        >
          <template v-slot:icon>
            <i class="bi bi-file-earmark-text	text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>


      <hr>

      <li class="nav-item">
        <h6 style="margin-left:15px">Tanımlar</h6>
        <hr>
      </li>
<!--
      <li class="nav-item">
        <sidenav-item
            to="/definitions-contract-fields"
            :class="getRoute() === 'definitions-contract-fields' ? 'active' : ''"
            :navText="isRTL ? 'Sözleşme Alan Tanımları' : 'Sözleşme Alan Tanımları'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
-->

      <li class="nav-item">
        <sidenav-item
            class="navmenuitems"
            to="/definitions-roles"
            :class="getRoute() === 'definitions-roles' ? 'active' : ''"
            :navText="isRTL ? 'Personel Rol Tanımları' : 'Personel Rol Tanımları'"
        >
          <template v-slot:icon>
            <i class="bi bi-gear text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
            class="navmenuitems"
            to="/osgb-branch"
            :class="getRoute() === 'osgb-branch' ? 'active' : ''"
            :navText="isRTL ? 'OSGB Şubeleri' : 'OSGB Şubeleri'"
        >
          <template v-slot:icon>
            <i class="bi bi-bank	  text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>


      <li class="nav-item">
        <hr>
        <h6 style="margin-left:15px">Mali Tanımlar</h6>
        <hr>
      </li>


      <li class="nav-item">
        <sidenav-item
            class="navmenuitems"
            to="/seniority-burden"
            :class="getRoute() === 'seniority-burden' ? 'active' : ''"
            :navText="isRTL ? 'Kıdem Tavanı' : 'Kıdem Tavanı'"
        >
          <template v-slot:icon>
            <i class="bi bi-award	text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>


      <li class="nav-item">
        <sidenav-item
            class="navmenuitems"
            to="/sgk-ceiling"
            :class="getRoute() === 'sgk-ceiling' ? 'active' : ''"
            :navText="isRTL ? 'SGK Tavanı' : 'SGK Tavanı'"
        >
          <template v-slot:icon>
            <i class="bi bi-award	text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>



      <li class="nav-item">
        <sidenav-item
            class="navmenuitems"
            to="/sgk-rate"
            :class="getRoute() === 'sgk-rate' ? 'active' : ''"
            :navText="isRTL ? 'SGK Oranları' : 'SGK Oranları'"
        >
          <template v-slot:icon>
            <i class="bi bi-person-badge		text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>


      <li class="nav-item">
        <sidenav-item
            class="navmenuitems"
            to="/company-management-expense"
            :class="getRoute() === 'company-management-expense' ? 'active' : ''"
            :navText="isRTL ? 'Yönetim Gideri' : 'Yönetim Gideri'"
        >
          <template v-slot:icon>
            <i class="bi bi-bar-chart-line	text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <!--
      <li class="nav-item">
        <sidenav-item
            class="navmenuitems"
            to="/monthly-osgb-sales-amount"
            :class="getRoute() === 'monthly-osgb-sales-amount' ? 'active' : ''"
            :navText="isRTL ? 'Aylık OSGB Satış Tutarı' : 'Aylık OSGB Satış Tutarı'"
        >
          <template v-slot:icon>
            <i class="bi bi-bar-chart-line	text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
-->
<!--      <li class="nav-item">-->
<!--        <sidenav-item-->
<!--            to="/definitions-company-categories"-->
<!--            :class="getRoute() === '/definitions-company-categories' ? 'active' : ''"-->
<!--            :navText="isRTL ? 'Firma Kategori' : 'Firma kategori'"-->
<!--        >-->
<!--          <template v-slot:icon>-->
<!--            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>-->
<!--          </template>-->
<!--        </sidenav-item>-->
<!--      </li>-->




    </ul>
  </div>

  <!--  <div class="pt-3 mx-3 mt-3 sidenav-footer">-->
  <!--    <sidenav-card-->
  <!--      :card="{-->
  <!--        title: 'Need Help?',-->
  <!--        description: 'Please check our docs',-->
  <!--        links: [-->
  <!--          {-->
  <!--            label: 'Documentation',-->
  <!--            route:-->
  <!--              'https://www.creative-tim.com/learning-lab/vue/overview/argon-dashboard/',-->
  <!--            color: 'dark',-->
  <!--          },-->
  <!--          {-->
  <!--            label: 'Buy now',-->
  <!--            route:-->
  <!--              'https://www.creative-tim.com/product/vue-argon-dashboard-pro?ref=vadp',-->
  <!--            color: 'success',-->
  <!--          },-->
  <!--        ],-->
  <!--      }"-->
  <!--    />-->
  <!--  </div>-->
</template>

<style scoped>
.navMenuItems{
  font-size: 17px;
  padding-left: 0;
}
</style>
